import $ from "jquery";

$(document).ready(function () {

   $(".js-slider-center").slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      mobileFirst: true,
      nextArrow: ".slider-navigation--center .js-slide-next",
      prevArrow: ".slider-navigation--center .js-slide-prev",
   });

   // articles
   let articleElementsCount = document.querySelectorAll(
      ".js-slider-articles .slide"
   ).length;
   if (articleElementsCount === 1) {
      $(".js-slider-articles").addClass("slider--single");
      $(".js-slider-articles").next(".slider-navigation").hide();
   }

   if ($(".js-slider-articles .slide").length == 2) {
      $(".js-slider-articles").css("--maxWidthDesktop", "350px");
   }

   let totalDesktopSlides = 3;
   if ($(".js-slider-articles .slide").length === 2) {
      totalDesktopSlides = 2;
   } else if (
      $(".js-slider-articles .slide").length === 3 ||
      $(".js-slider-articles .slide").length > 3
   ) {
      totalDesktopSlides = 3;
   }




   $(".js-slider-articles").slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      mobileFirst: true,
      nextArrow: ".slider-navigation--articles .js-slide-next",
      prevArrow: ".slider-navigation--articles .js-slide-prev",
      responsive: [
         {
            breakpoint: 700,
            settings: {
               slidesToShow: 2
            }
         },
         {
            breakpoint: 1100,
            settings: {
               slidesToShow:
                  $(".js-slider-articles .slide").length > 1
                     ? totalDesktopSlides
                     : 1,
            },
         },
      ],
   });

   let imageSliders = $(".js-image-slider");
   $(imageSliders).each(function (index) {
      let nextArrow = $(this).parent().find(".js-slide-next");
      let prevArrow = $(this).parent().find(".js-slide-prev");
      $(this).slick({
         dots: false,
         arrows: true,
         infinite: true,
         speed: 300,
         slidesToShow: 1,
         centerMode: false,
         mobileFirst: true,
         nextArrow: nextArrow,
         prevArrow: prevArrow,
      });
   });
});
